<template>
  <div class="ui left aligned container">
    <div class="ui form">
      <div class="inline fields">
        <div class="field">
          <label>艺人</label>
          <select v-model="id">
            <option value="1">孟美岐</option>
            <option value="2">吴宣仪</option>
            <option value="3">杨超越</option>
            <option value="4">段奥娟</option>
            <option value="5">yamy</option>
            <option value="6">赖美云</option>
            <option value="7">张紫宁</option>
            <option value="8">杨芸晴</option>
            <option value="9">李紫婷</option>
            <option value="10">傅菁</option>
            <option value="11">徐梦洁</option>
          </select>
        </div>
        <div class="field">
          <label>size</label>
          <select v-model="size">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="60">60</option>
            <option value="90">90</option>
          </select>
        </div>
      </div>
    </div>

    <vuetable ref="vuetable"
              :api-url="'/albums/' + id + '?albumid=' + albumid"
              :fields="columns"
              :perPage="size"
              @vuetable:load-success="onLoadDataSuccess"
              @vuetable:pagination-data="onPaginationData">
    </vuetable>
    <div class="ui grid">
      <div class="ui left aligned six wide column">
        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      </div>
      <div class="right floated six wide column">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div>
    </div>
    <div class="ui hidden divider"></div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
  @media screen and (min-width:960px) {
    #chart {
      width: 900px;
      height: 400px;
    }
  }
</style>
<script>
  import Vuetable from '../../table/Vuetable.vue'
  import VuetablePagination from '../../table/VuetablePagination.vue'
  import VuetablePaginationInfo from '../../table/VuetablePaginationInfo.vue'
  import ECharts from 'vue-echarts'

  export default {
    name: 'Album',
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
      'v-chart': ECharts
    },
    data () {
      return {
        id: 3,
        size: 10,
        albumid: this.$route.params.id || 4359159,
        options: null,
        columns: [
          {name: 'time', title: '日期', callback: 'date'},
          {name: 'newPeople', title: '今日新增人数'},
          {name: 'totalPeople', title: '总助燃人数'},
          {name: 'todayCount', title: '今日助燃次数'},
          {name: 'totalCount', title: '总助燃次数'},
        ]
      }
    },
    beforeRouteUpdate (to, from, next) {
      this.albumid = to.params.id;
      next();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onLoadDataSuccess (response) {
        this.options =
            {
              title: {
                text: '增幅'
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['新增人数', '助燃次数']
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: '新增人数',
                  type: 'line',
                  data: response.data.content.map(e => [e.time, e.newPeople])
                },
                {
                  name: '助燃次数',
                  type: 'line',
                  data: response.data.content.map(e => [e.time, e.todayCount])
                },
              ]
            };
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      link: function (value, item) {
        return '<a href="https://y.qq.com/m/digitalbum/gold/index.html?_video=true&id='+this.albumid+'#singercall/'
            + item.singerid + '" target="_blank">' + value + '</a>';
      },
      date: function (value) {
        let date = new Date(value);
        return date.toISOString().substring(0, 10);
      }
    }
  }
</script>
